/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("digiexam").
controller("OverviewTeacherController", function OverviewTeacherController(
	$scope,
	$filter,

	dxApi,
	dxExamsFilters,
	Node,
	NodeRepository,
	dxSession,
	DX_URLS,
	dxLocalize,
	DX_EXAMS_STEPS,
	dxExamsNavigator,
	dxSearchSortOptions,
	dxAngularConstantHelper
) {
	"use strict";

	$scope.Urls = DX_URLS;
	$scope.dxSession = dxSession;

	$scope.node = new Node();

	$scope.dxExamsNavigator = dxExamsNavigator;
	$scope.DX_EXAMS_STEPS = DX_EXAMS_STEPS;
	$scope.DX_ARTICLE_TYPE = dxAngularConstantHelper.DX_ARTICLE_TYPE;
	$scope.loading = true;

	$scope.errors = {
		exams: "",
	};

	$scope.exams = {
		ongoing: [],
		ungraded: [],
		scheduled: [],
		totalOngoing: 0,
		totalUngraded: 0,
		totalScheduled: 0,
	};

	var maxExams = 3;

	// Keep full lists in memory in case any are moved from scheduled to ongoing.
	var scheduled = [];
	var ongoing = [];

	NodeRepository.load(dxSession.getRole().organizationId).then(onNodeLoadSuccess);

	function onNodeLoadSuccess(node) {
		$scope.node = node;
	}

	function getExams() {
		dxApi.v1.exams.get().then(onGetExamsSuccess, onGetExamsError);

		function onGetExamsSuccess(res) {
			$scope.loading = false;

			var exams = res.data;

			ongoing = $filter("orderBy")(exams.filter(dxExamsFilters.ongoingExamsFilter), dxSearchSortOptions.ongoingExams.sortOptions[0].value);
			var ungraded = $filter("orderBy")(exams.filter(dxExamsFilters.ungradedExamsFilter), dxSearchSortOptions.exams.sortOptions[0].value);
			scheduled = exams.filter(dxExamsFilters.scheduledExamsFilter).sort(dxSearchSortOptions.scheduledExams.sortOptions[0].value);

			$scope.exams.totalOngoing = ongoing.length;
			$scope.exams.totalUngraded = ungraded.length;
			$scope.exams.totalScheduled = scheduled.length;

			$scope.exams.ongoing = ongoing.slice(0, maxExams);
			$scope.exams.ungraded = ungraded.slice(0, maxExams);
			$scope.exams.scheduled = scheduled.slice(0, maxExams);
		}

		function onGetExamsError() {
			$scope.loading = false;

			$scope.errors.exams = dxLocalize.get("Error.LoadingExams");
		}
	}

	$scope.addExamToOngoing = function addExamToOngoing(exam, step) {
		if (step !== DX_EXAMS_STEPS.ongoing) {
			return;
		}

		ongoing.push(exam);
		ongoing = $filter("orderBy")(ongoing, dxSearchSortOptions.ongoingExams.sortOptions[0].value);
		$scope.exams.totalOngoing = ongoing.length;
		$scope.exams.ongoing = ongoing.slice(0, maxExams);
	};

	$scope.removeExamFromScheduled = function removeExamFromScheduled(exam, step) {
		if (step !== DX_EXAMS_STEPS.scheduled) {
			return;
		}

		scheduled = scheduled.filter(function remove(e) {
			return e.id !== exam.id;
		});

		$scope.exams.totalScheduled = scheduled.length;
		$scope.exams.scheduled = scheduled.slice(0, maxExams);
	};

	getExams();
});
